// @flow
import React from 'react';
import { EFPDirectory } from '../components/efp-directory';

export const EFPDirectoryView = () => (
  <EFPDirectory />
);
